import { createSlice } from "@reduxjs/toolkit";

const complianceTaskSlice = createSlice({
  name: "complianceTask",
  initialState: {},
  reducers: {
    setTaskId: (state, action) => {
      const { communityId, taskId, docType } = action.payload;

      // ✅ If docType provided (finance, insurance), nest under it
      if (docType) {
        if (!state[communityId] || typeof state[communityId] !== "object") {
          state[communityId] = {};
        }
        state[communityId][docType] = taskId;
      }
      // ✅ Otherwise, keep your old logic (for StartCompliance)
      else {
        state[communityId] = taskId;
      }
    },

    clearTaskId: (state, action) => {
      const { communityId, docType } = action.payload;

      // ✅ If docType given, remove only that type
      if (
        docType &&
        state[communityId] &&
        typeof state[communityId] === "object"
      ) {
        delete state[communityId][docType];
        if (Object.keys(state[communityId]).length === 0) {
          delete state[communityId];
        }
      }
      // ✅ Otherwise, delete entire entry (existing behavior)
      else {
        delete state[communityId];
      }
    },
  },
});

export const { setTaskId, clearTaskId } = complianceTaskSlice.actions;
export default complianceTaskSlice.reducer;
